// BASIC CAROUSEL ITEM 

export const basicTemplate = (optionalClasses, newsUrl, imgSrc, newsTitle, infoTemplate) =>`
<div class="carousel-item ${optionalClasses}" >
    <a class="thumb-cont" href="${newsUrl}">
        <picture>
            <img loading="lazy" src="${imgSrc}" alt="${newsTitle}" />
        </picture>
        ${infoTemplate}
    </a>
</div>`;